<template>
    <div class="operation_box">
		<!-- Table Actions -->
		<div class="operation_item" v-if="allowedActions.length > 0">
			<el-dropdown split-button type="primary"
						 @click="allowedActions[0].execute"
						 @command="(command) => command()"
			>
				<i :class="allowedActions[0].icon"></i>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="action in allowedActions"
									  :key="action.key"
									  :icon="action.icon"
									  :command="action.execute">
						{{ $t(action.key) }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
    </div>
</template>

<script>
import {fileuploadApi} from "@/common/api/fileuploadApi";
import {enumDef} from "@/common/enumDefs";

export default {
    data() {
        return {
			actionList: [
				{
					key: "revolvingPutOption.table.operation.downloadContract",
					icon: "fa fa-cloud-download",
					isEnabled: this.hasContractFile,
					execute: this.downloadContract
				},
				{
					key: "revolvingPutOption.table.operation.showRequiredAssignmentConfirmations",
					icon: "fa fa-check",
					isEnabled: this.hasOpenConfirmations,
					execute: this.showConfirmations
				},
				{
					key: "revolvingPutOption.table.operation.cancelContractExtraordinary",
					icon: "fa fa-times",
					isEnabled: this.canCancel,
					execute: this.cancelExtraordinary
				},
			]
        };
    },
	computed: {
    	status() {
    		return this.params.data.status;
		},
		allowedActions() {
			return this.actionList.filter(action => action.isEnabled());
		}
	},
	methods: {
		handleActionCommand(command) {
			command();
		},
		hasContractFile() {
			return this.params.data.contractFileId;
		},
		hasOpenConfirmations() {
			return this.params.data.toBeConfirmedCount > 0;
		},
		canCancel() {
			return enumDef.revolvingPutOptionStatus.isAcceptedOrRunning(this.params.data.status);
		},
		downloadContract() {
			let pdfUrl = fileuploadApi.getPdfUrl(this.params.data.contractFileId);
			window.open(pdfUrl, "_blank");
		},
		showConfirmations() {
			this.params.showConfirmations(this.params.data);
		},
		cancelExtraordinary() {
			this.params.cancelExtraordinary(this.params.data);
		},
	}
};
</script>